<template>
	<div>
	<footer id="footer">
		<div class="footerNav">
			<div class="container">
				<ul>
					<li>
						<h2>产品信息</h2>
            <div v-if="routePath === '/product.html'">
              <a v-for="(item, index) in this.product_categorys" @click="goAnchorInFooter('/product.html?floor-'+(index+1), 'floor-'+(index+1))">{{ item.cname }}</a>
            </div>
            <div v-else>
              <a v-for="(item, index) in this.product_categorys" @click="goAnchorInFooter('/product.html', 'floor-'+(index+1))">{{ item.cname }}</a>
            </div>
					</li>
					<li>
						<h2>专业服务</h2>
            <div v-if="routePath === '/service.html'">
              <a @click="goAnchorInFooter('/service.html?service', 'service')">服务范畴</a>
              <a @click="goAnchorInFooter('/service.html?quality', 'quality')">高端品质</a>
              <a @click="goAnchorInFooter('/service.html?speciality', 'speciality')">专业服务</a>
            </div>
            <div v-else>
              <a @click="goAnchorInFooter('/service.html', 'service')">服务范畴</a>
              <a @click="goAnchorInFooter('/service.html', 'quality')">高端品质</a>
              <a @click="goAnchorInFooter('/service.html', 'speciality')">专业服务</a>
            </div>
					</li>
					<li>
						<h2>新闻中心</h2>
            <router-link to="/news.html">企业动态</router-link>
            <router-link to="/industryNews.html">行业新闻</router-link>
            <router-link to="/commonSense.html">印刷常识</router-link>
					</li>
					<li>
						<h2>关于我们</h2>
            <div v-if="routePath === '/about.html'">
              <a @click="goAnchorInFooter('/about.html?about', 'about')">公司简介</a>
              <a @click="goAnchorInFooter('/about.html?culture', 'culture')">企业文化</a>
              <a @click="goAnchorInFooter('/about.html?iso', 'iso')">体系认证</a>
              <a @click="goAnchorInFooter('/about.html?customer', 'customer')">合作客户</a>
            </div>
            <div v-else>
              <a @click="goAnchorInFooter('/about.html', 'about')">公司简介</a>
              <a @click="goAnchorInFooter('/about.html', 'culture')">企业文化</a>
              <a @click="goAnchorInFooter('/about.html', 'iso')">体系认证</a>
              <a @click="goAnchorInFooter('/about.html', 'customer')">合作客户</a>
            </div>
					</li>
					<li>
						<h2>联系我们</h2>
            <div v-if="routePath === '/contact.html'">
              <router-link to="/contact.html">联系我们</router-link>
              <a @click="goAnchorInFooter('/contact.html?jobs', 'jobs')">人才招聘</a>
            </div>
            <div v-else>
              <router-link to="/contact.html">联系我们</router-link>
              <a @click="goAnchorInFooter('/contact.html', 'jobs')">人才招聘</a>
            </div>
					</li>
				</ul>
			</div>
		</div>
		<div class="copyright">
			<div class="container">
				<div class="icp">
					Copyright © 2007-{{ new Date().getFullYear() }} 惠州得胜彩印有限公司版权所有。
					<a href="http://beian.miit.gov.cn" target="_blank" rel="nofollow" style="color: #999;">粤ICP备13011833号-1</a>
					<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44132202100063" target="_blank" rel="nofollow" style="color: #999;">
						<img style="position: relative;top: -2px;margin-left: 7px;" :src="imgPrefix + 'static/beian.png'">
						粤公网安备44132202100063号
					</a>
				</div>

				<div class="icons">
					<span><img :src="imgPrefix + 'static/foot_icon1.jpg'">服务热线：0752-6383576</span>
					<span><img :src="imgPrefix + 'static/foot_icon2.jpg'">服务时间：9:00-22:00</span>
				</div>
			</div>
		</div>
	</footer>

	<footer id="m-footer">
		<ul>
			<li>
				<router-link to="/">首页</router-link>
			</li>
			<li>
				<router-link to="/product.html">产品信息</router-link>
			</li>
			<li>
				<router-link to="/service.html">专业服务</router-link>
			</li>
			<li>
				<router-link to="/news.html">新闻动态</router-link>
			</li>
			<li>
				<router-link to="/about.html">关于我们</router-link>
			</li>
			<li>
				<router-link to="/contact.html">联系我们</router-link>
			</li>
		</ul>
		<div class="contact">
			<div class="tel"><img :src="imgPrefix + 'static/m-tel.jpg'">+86-752-6383576</div>
			<div class="service"><img :src="imgPrefix + 'static/m-qq.jpg'">服务时间：9:00-22:00</div>
		</div>
		<div class="m-copyright">
			Copyright © 2007-{{ new Date().getFullYear() }} 惠州得胜彩印有限公司版权所有。
		</div>
	</footer>
	</div>
</template>

<script>
	import {getProductCategoryList} from "../axios/api";

  export default {
		name: 'Footer',
		data() {
		  return {
        imgPrefix: process.env.PREFIX_IMG,
        routePath: this.$route.path,
        product_categorys: [],
		  }
		},
    mounted() {
      this.getProductCategorys();
    },
    methods:{
		  goAnchorInFooter(path, id) {
        localStorage.setItem("anchorId", id);
        this.$router.push({ path: path });
      },
      getProductCategorys(){
        getProductCategoryList({sort: 'sort', order: 'asc', filter_params: {'display_state': 1}}).then(response => {
          this.product_categorys = response.data.data.list;
        }).catch(error => {
				console.log('请求异常信息：'+error);
			  });
      },
    }
	}
</script>

<style>
	.footerNav{
		padding-top: 35px;
		min-height: 0;
		overflow: hidden;
		margin-bottom: 22px;
	}
	.footerNav ul li{
		width: 20%;
		float: left;
	}
	.footerNav ul li h2{
		color: #fff;
		font-size: 20px;
		margin-bottom: 19px;
	}
	.footerNav ul li a{
		color: #878787 !important;
		display: block;
		font-size: 16px;
		cursor: pointer;
		margin-bottom: 8px;
	}

	.footerNav ul li a:hover{
		color: #fff !important;
	}


	#footer{
		height: 355px;
		background: #1a1a1a;
	}
	.footer-content{
		height: 120px;
		background: #343436;
		border-bottom: 2px solid #99e7ff;
	}

	.icp{
		float: left;
		font-size: 14px;
		color: #999999;
		padding-top: 25px;
	}

	.footer-content li h2{
		font-size: 18px;
		color: #bebebe;
	}

	.footer-content li p{
		font-size: 14px;
		color: #999999;
	}

	.footer-content ul li{
		width: 28%;
		float: left;
		color: #fff;
		margin-top: 35px;
	}

	.footer-content ul li:first-child{
		width: 41%;
		margin-left: 3%;
	}

	.footer-content ul li .icon{
		float: left;
		margin-right: 20px;
	}

	.copyright ul li:last-child{
		border: none;
	}

	.copyright ul li a{
		color: #999 !important;
	}

	.copyright ul li a:hover{
		color: #00a0e9 !important;
		text-decoration: none;
	}

	.copyright{
		height: 72px;
		background:#1a1a1a;
		border-top: 1px solid #0d6f8d;
	}

	.copyright ul li{
		float: left;
		font-size: 15px;
		color: #999999;
		margin-top: 30px;
		margin-left: 15px;
		padding-right: 15px;
		line-height: 17px;
		border-right:1px solid #232323;
	}

	.copyright .icons{
		float: right;
		font-size: 14px;
		color: #999999;
		margin-top: 23px;
	}

	.copyright .icons{
		margin-left: 38px;
	}

	.copyright .icons span{
		margin-left: 32px;
	}

	.copyright .icons span img{
		margin-right: 5px;
	}

	#m-footer{
		background: #2a2a2c;
		display: none;
	}

	#m-footer a{
		color: #cccccc;
		display: block;
		text-decoration: none;
	}

	#m-footer ul li{
		line-height: 55px;
		border-bottom: 1px solid #444444;
		text-indent: 20px;
		background: url('https://img.ds-cy.com/static/menu-jiantou.jpg') no-repeat;
		background-position: 97% center;
		background-size: 20px;
	}

	#m-footer .contact{
		height: 65px;
		line-height: 65px;
	}

	#m-footer .contact > div{
		width: 45%;
		float: left;
		color: #999999;
		font-size: 17px;
	}

	#m-footer .contact > div:last-of-type{
		width: 55%;
	}

	#m-footer .contact > div img{
		margin-left: 30px;
		margin-right: 5px;
		width: 33px;
	}

	.m-copyright{
		height: 55px;
		font-size: 14px;
		line-height: 55px;
		background: #000000;
		color: #999999;
		text-align: center;
		border-top: 2px solid #01bff8;
	}

	@media (max-width:1199px) {
		.footer-content ul li .icon{
			margin-right: 10px;
		}
		.footer-content ul li:first-child {
		    width: 50%;
		    margin-left: 1%;
		}
		.footer-content ul li{
			width: 24%;
		}
	}

	@media (max-width:992px) {
		#footer{
			display: none;
		}
		#m-footer{
			display: block;
		}
	}

	@media (max-width:767px) {
		.m-copyright{
			font-size: 12px;
		}
		#m-footer .contact > div{
			font-size: 12px;
		}
		#m-footer .contact > div img {
		    margin-left: 20px;
		    width: 24px;
		}
		#m-footer .contact {
		    height: 55px;
		    line-height: 55px;
		}
		#m-footer ul li{
			line-height: 50px;
			font-size: 15px;
		}
		#m-footer ul li{
			    background-size: 15px;
		}
		#m-footer{
			display: block;
		}
	}

	@media (max-width:1440px) {
		.icp{
			font-size: 12px !important;
			text-align: center;
			display: block;
			float: initial;
		}
		.copyright .icons{
			display: none;
		}
	}

	@media (max-width:350px) {
		#m-footer .contact{
			overflow: hidden;
		}
		#m-footer ul li{
			text-indent: 12px;
		}
		.m-copyright{
			font-size: 11px;
			overflow: hidden;
		}
		#m-footer .contact > div img{
			margin-left: 12px;
		}
		#m-footer .contact > div:last-of-type {
		    width: 53%;
		}
		#m-footer .contact > div:first-of-type {
		    width: 46%;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue